import { Spinner } from "@salesapp/ui";
import type { DashboardTableItem } from "../api";
import { Card } from "./UiCard";

export function TableCard({ item, rows, loading }: {
  item: DashboardTableItem;
  rows: Record<string, unknown>[];
  loading: boolean;
}) {
  return (
    <Card title={item.title} className="dashboard-table-card">
      {loading ? <Spinner /> : rows.length === 0 ? (
        <p className="dashboard-table-card__empty">No data yet.</p>
      ) : (
        <table className="dashboard-table-card__table">
          <thead>
            <tr>{(item.columns ?? []).map(c => <th key={c}>{c}</th>)}</tr>
          </thead>
          <tbody>
            {rows.map((row, i) => (
              <tr key={i}>{(item.columns ?? []).map(c => <td key={c}>{String(row[c] ?? "—")}</td>)}</tr>
            ))}
          </tbody>
        </table>
      )}
    </Card>
  );
}
